"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../structures/LootTable"));
const TalismanTable = new LootTable_1.default()
    .add('Air talisman', 1, 10)
    .add('Body talisman', 1, 10)
    .add('Earth talisman', 1, 10)
    .add('Fire talisman', 1, 10)
    .add('Mind talisman', 1, 10)
    .add('Water talisman', 1, 10)
    .add('Cosmic talisman', 1, 4)
    .add('Chaos talisman', 1, 3)
    .add('Nature talisman', 1, 3);
exports.default = TalismanTable;
//# sourceMappingURL=TalismanTable.js.map